// ── Time Shift — the skin that follows the clock ─────────────────────────────
// Jason (2026-09-16): "the last one which changes color based on a show is
// fantastic, we need more like that, perhaps a time shift one." Same mechanism
// as Now Playing (lib/nowPlaying.js writes --np-accent/--np-vivid and index.css
// breathes --amber between them), but the palette comes from the hour: rose-gold
// at dawn, the brand amber through the day, ember at dusk, a cool violet late.
// Colours interpolate minute by minute, so the app dims with the room.

const STOPS = [
  // hour, accent, vivid, bg, raised
  [0,  '#8fa6ff', '#c7d3ff', '#04040a', '#0a0a16'],   // late night · cool violet
  [5,  '#8fa6ff', '#c7d3ff', '#04040a', '#0a0a16'],
  [7,  '#f0a06a', '#ffd2a8', '#0a0706', '#161010'],   // dawn · rose gold
  [10, '#f5c842', '#ffe08a', '#040406', '#0a0a14'],   // day · the brand amber
  [17, '#f5c842', '#ffe08a', '#040406', '#0a0a14'],
  [20, '#f08a3a', '#ffb877', '#0a0605', '#160d0a'],   // dusk · ember
  [23, '#8fa6ff', '#c7d3ff', '#04040a', '#0a0a16'],   // night
  [24, '#8fa6ff', '#c7d3ff', '#04040a', '#0a0a16'],
]

const hex = (h) => [1, 3, 5].map(i => parseInt(h.slice(i, i + 2), 16))
const toHex = (rgb) => '#' + rgb.map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('')
const mix = (a, b, t) => toHex(hex(a).map((v, i) => v + (hex(b)[i] - v) * t))

export function paletteForHour(h) {
  const x = ((h % 24) + 24) % 24
  let i = 0
  while (i < STOPS.length - 2 && STOPS[i + 1][0] <= x) i++
  const [h0, a0, v0, b0, r0] = STOPS[i], [h1, a1, v1, b1, r1] = STOPS[i + 1]
  const t = h1 === h0 ? 0 : (x - h0) / (h1 - h0)
  return { accent: mix(a0, a1, t), vivid: mix(v0, v1, t), bg: mix(b0, b1, t), raised: mix(r0, r1, t) }
}

const hexRgb = (h) => hex(h).join(',')
export function applyTimeShift(now = new Date()) {
  if (typeof document === 'undefined') return
  const root = document.documentElement
  if (!root.classList.contains('theme-timeshift')) return
  const pal = paletteForHour(now.getHours() + now.getMinutes() / 60)
  root.style.setProperty('--np-accent', pal.accent)
  root.style.setProperty('--np-vivid', pal.vivid)
  root.style.removeProperty('--amber')
  root.style.setProperty('--amber-rgb', hexRgb(pal.accent))
  root.style.setProperty('--amber-vivid', pal.vivid)
  root.style.setProperty('--amber-dim', `rgba(${hexRgb(pal.accent)},0.75)`)
  root.style.setProperty('--amber-glow', `rgba(${hexRgb(pal.accent)},0.22)`)
  root.style.setProperty('--bg', pal.bg)
  root.style.setProperty('--bg-rgb', hexRgb(pal.bg))
  root.style.setProperty('--bg-raised', pal.raised)
  root.style.setProperty('--nav-bg', `rgba(${hexRgb(pal.bg)},0.97)`)
  root.style.setProperty('--scrim', `rgba(${hexRgb(pal.bg)},0.78)`)
  root.style.setProperty('--sheet', `linear-gradient(160deg, ${pal.raised}, ${pal.bg})`)
}

let timer = null
export function startTimeShift() {
  stopTimeShift()
  applyTimeShift()
  timer = setInterval(() => applyTimeShift(), 60 * 1000)
}
export function stopTimeShift() { if (timer) { clearInterval(timer); timer = null } }
